<template>
  <div>
    <div class="highlight text-white">
      <div class="container">
        <div class="row">
          <div class="col-md d-none d-lg-block">
            <div class="cubes">
              <cubes />
            </div>
          </div>
          <div class="col-md">
            <div class="heading">
              <h1>{{ $t("coaching.headline") }}</h1>
              <p>{{ $t("coaching.claim") }}</p>
              <router-link :to="{ name: 'coaching-home', hash: '#current-course-portfolio' }">{{ $t("coaching.currentCoursePortfolio") }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="coaching-page container mt-4">
      <!-- Services Section -->
      <featurette-item id="featurette-1" :title="$t('coaching.featurette1Headline')" textPath="coaching.featurette1Description" :img="imgWorkshop" :copyright="'© David Travis'" />
      <hr class="divider" />
      <featurette-item id="featurette-2" :title="$t('coaching.featurette2Headline')" textPath="coaching.featurette2Description" :img="imgFlipchart" :copyright="'© Kevin Woblick'" :imgLeft="true" />
      <hr class="divider" />
      <featurette-item id="featurette-3" :title="$t('coaching.featurette3Headline')" textPath="coaching.featurette3Description" :img="imgConfCallPlant" :copyright="'© Sigmund'" />
      <hr class="divider" />

      <!-- Testimonials -->
      <h2>{{ $t("coaching.testimonialsHeadline") }}</h2>

      <testimonial :text="$t('coaching.testimonial1Content')" class="mb-4 mt-4" />
      <Testimonial :text="$t('coaching.testimonial2Content')" class="mb-4" />
      <Testimonial :text="$t('coaching.testimonial3Content')" />

      <hr class="divider" />

      <!-- Courses Portfolio -->
      <h2 class="mb-4" id="current-course-portfolio">{{ $t("coaching.currentCoursePortfolio") }}</h2>
      <div>
        <CourseBox :headline="$t('coaching.course1Title')" :text="$t('coaching.course1Description')" :accent="'#e71d36'" :duration="$t('coaching.durationHalfToTwoDays')" :format="$t('coaching.formatVirtualAndOnSite')" :trainer="'Monika'" />
      </div>
      <div>
        <CourseBox :headline="$t('coaching.course2Title')" :text="$t('coaching.course2Description')" :accent="'rgb(167, 203, 103)'" :duration="$t('coaching.durationOneDay')" :format="$t('coaching.formatOnSite')" :trainer="'Monika'" />
      </div>
      <div>
        <CourseBox :headline="$t('coaching.course3Title')" :text="$t('coaching.course3Description')" :accent="'rgb(244, 96, 54)'" :duration="$t('coaching.durationOneToTwoDays')" :format="$t('coaching.formatVirtual')" :trainer="'Daniel'" />
      </div>

      <hr class="divider" />

      <!-- Contact Section -->
      <div class="contact">
        <h2>{{ $t("coaching.callToActionHeadline") }}</h2>
        <p>{{ $t("coaching.callToActionSubline") }}</p>
        <a href="/contact" class="contact-link">{{ $t("coaching.contactUs") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Cubes from "@/components/general/Cubes";
import FeaturetteItem from "@/components/general/FeaturetteItem";
import Testimonial from "@/components/general/Testimonial.vue";
import CourseBox from "@/components/general/CourseBox.vue";

import imgWorkshop from "@/assets/img/workshop-notes.jpg";
import imgConfCallPlant from "@/assets/img/conf-call-plant.jpg";
import imgFlipchart from "@/assets/img/flipchart.jpg";

export default {
  name: "Coaching",

  components: {
    CourseBox,
    Cubes,
    FeaturetteItem,
    Testimonial
  },

  computed: {
    imgWorkshop() {
      return imgWorkshop;
    },
    imgConfCallPlant() {
      return imgConfCallPlant;
    },
    imgFlipchart() {
      return imgFlipchart;
    }
  }
};
</script>

<style lang="scss" scoped>
.coaching-page {
  font-family: sans-serif;
  padding: 2rem;
  line-height: 1.6;
}

.highlight {
  background: rgb(167, 203, 103);
  background: linear-gradient(142deg, rgba(167, 203, 103, 1) 13%, rgba(27, 153, 139, 1) 42%, rgba(231, 29, 54, 1) 75%, rgba(244, 96, 54, 1) 90%);

  max-height: calc(100vh - #{$navbar-height});
  height: 600px;
}

.cubes {
  margin-top: 1rem;
}

.contact {
  font-size: 1.25rem;
  font-weight: 300;
  text-align: center;
}

.contact-link {
  display: inline-block;
  margin-top: 1rem;
  background: rgb(167, 203, 103);
  color: white;
  padding: 0.75rem 1.5rem;
  text-decoration: none;
  :hover {
    text-decoration: none;
  }
}

.heading {
  padding-top: 11rem;
  h1 {
    font-size: 56px;
  }
  p {
    padding-top: 1rem;
    font-size: larger;
  }
  a {
    color: white;
    font-weight: 700;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
